import service from "../../services/gestionTiempos/gestionTiempos";
import filters from "../../models/gestionTiempos/filters";
import moment from "moment";

export default {
  namespaced: true,
  state: {
    service: new service(),
    itemsEmployees: [],
    labelEmployees: [],
    attributes: [],
    groups: [],
    schedule: [],
    models: [],
    date: localStorage.getItem("fechaFiltroDesde")
      ? localStorage.getItem("fechaFiltroDesde")
      : new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
    dateTo: localStorage.getItem("fechaFiltroHasta")
      ? localStorage.getItem("fechaFiltroHasta")
      : new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
    filtersId: [],
    filters: [],
    newFilter: {},
    normals: ["Licencia por hora", "Licencia por día", "Sin novedades"],
    novedades: [],
    regis: [],
    defaultFilter: {},
    saveFilter: [],
    processNovelty: {},
    refreshNovelty: [],
    dateForRefresh: null,
    dataEmployed: {},
    signed: false,
    deleteDisabled: false,
    filterReadOnly: [],
    filterForShow: [],
    idFilterShow: null,
    updatedFilter: [],
    filterApply: [],
    dataFilterApply: [],
    deselectItems: [],
    dateFromComponents: null,
    dateToComponents: null,
    checkTo: false,
    addRegistration: false,
    timeFrom: moment("00:00", "HH:mm").format("HH:mm"),
    timeTo: moment("00:00", "HH:mm").format("HH:mm"),
    higherOrder: false,
  },
  mutations: {
    setEmployees(state, { item }) {
      state.itemsEmployees = item;
    },
    setAttributes(state, { item }) {
      state.attributes = item;
    },
    setGroups(state, { item }) {
      state.groups = item;
    },
    setSchedule(state, { item }) {
      state.schedule = item;
    },
    setModels(state, { item }) {
      state.models = item;
    },
    setDate(state, date) {
      state.date = date;
    },
    setDateTo(state, data) {
      state.dateTo = data;
    },
    setFilter(state, { item }) {
      state.filters = item;

      if (
        !state.defaultFilter ||
        Object.keys(state.defaultFilter).length === 0
      ) {
        state.defaultFilter = item.filter((option) => {
          return option.defaults === true;
        })[0];
      }
    },
    setDeleteFilter(state, id) {
      state.filtersId = id;
    },
    setNewFilter(state, data) {
      state.newFilter = data;
    },
    setFilters(state, { options }) {
      state.filters = options;
    },
    setNormals(state, { options }) {
      state.normals = options;
    },
    setController(state, { options }) {
      state.novedades = options;
    },
    setRegis(state, { options }) {
      state.regis = options;
    },
    setNewDefaultFilter(state, { filter }) {
      state.defaultFilter = filter;
    },
    setSaveFilter(state, data) {
      state.saveFilter = data;
    },
    setProcessNovelty(state, data) {
      state.processNovelty = data;
    },
    setRefreshNovelty(state, data) {
      state.refreshNovelty = data;
    },
    setDateForRefresh(state, data) {
      state.dateForRefresh = data;
    },
    setDataEmployed(state, data) {
      state.dataEmployed = data;
    },
    setSigned(state, data) {
      state.signed = data;
    },
    setDeleteDisabled(state, data) {
      state.deleteDisabled = data;
    },
    setFilterReadOnly(state, data) {
      state.filterReadOnly = data;
    },
    setFilterForShow(state, data) {
      state.filterForShow = data;
    },
    setIdFilterShow(state, data) {
      state.idFilterShow = data;
    },
    setUpdatedFilter(state, data) {
      state.updatedFilter = data;
    },
    setFilterApply(state, data) {
      state.filterApply = data;
    },
    setDataFilterApply(state, data) {
      state.dataFilterApply = data;
    },
    setDeselectItems(state, data) {
      state.deselectItems = data;
    },
    setDateFromComponents(state, data) {
      state.dateFromComponents = data;
    },
    setDateToComponents(state, data) {
      state.dateToComponents = data;
    },
    setCheckTo(state, data) {
      state.checkTo = data;
    },
    setDateDefault(state, data) {
      state.dateDefault = data;
    },
    setAddRegistration(state, data) {
      state.addRegistration = data;
    },
    setTimeFrom(state, data) {
      state.timeFrom = data;
    },
    setTimeTo(state, data) {
      state.timeTo = data;
    },
    setHigherOrder(state, data) {
      state.higherOrder = data;
    },
  },
  actions: {
    //obtengo empleados
    async getEmployees({ state, dispatch, commit }) {
      try {
        dispatch("loader/startLoading", null, { root: true });
        let item = await state.service.getEmployees();

        commit("setEmployees", { item });
      } catch (error) {
        console.log(error);
      } finally {
        dispatch("loader/stopLoading", null, { root: true });
      }
    },
    //obtengo atributos
    async getAttributes({ state, dispatch, commit }) {
      try {
        dispatch("loader/startLoading", null, { root: true });
        let item = await state.service.getAttributes(state.date);

        commit("setAttributes", { item });
      } catch (error) {
        console.log(error);
      } finally {
        dispatch("loader/stopLoading", null, { root: true });
      }
    },
    //obtengo grupos
    async getGroups({ state, dispatch, commit }) {
      try {
        dispatch("loader/startLoading", null, { root: true });
        let item = await state.service.getGroups(state.date);

        commit("setGroups", { item, name });
      } catch (error) {
        console.log(error);
      } finally {
        dispatch("loader/stopLoading", null, { root: true });
      }
    },
    //obtengo horarios
    async getSchedule({ state, dispatch, commit }) {
      try {
        dispatch("loader/startLoading", null, { root: true });
        let item = await state.service.getSchedule(state.date);

        commit("setSchedule", { item });
      } catch (error) {
        console.log(error);
      } finally {
        dispatch("loader/stopLoading", null, { root: true });
      }
    },
    //obtengo modelos
    async getModels({ state, dispatch, commit }) {
      try {
        dispatch("loader/startLoading", null, { root: true });
        let item = await state.service.getModels(state.date);

        commit("setModels", { item });
      } catch (error) {
        console.log(error);
      } finally {
        dispatch("loader/stopLoading", null, { root: true });
      }
    },
    //obtengo filtros
    async getFilters({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          let item = await state.service.getFilters();

          commit("setFilter", { item });
          resolve(true);
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },
    //elimino filtros
    async deleteFilter({ state, dispatch, commit }) {
      dispatch("loader/startLoading", null, { root: true });
      try {
        await state.service.deleteFilters(state.filtersId).then(() => {
          let options = state.filters;

          options = options.filter((option) => {
            return option.id != state.filtersId;
          });

          commit("setFilters", { options });
        });
      } catch (error) {
        console.log(error);
      } finally {
        dispatch("loader/stopLoading", null, { root: true });
      }
    },
    //nuevo filtro
    async newFilter({ state, dispatch, commit }) {
      try {
        dispatch("loader/startLoading", null, { root: true });
        await state.service.newFilter(state.newFilter).then((data) => {
          let options = state.filters;
          let item = state.newFilter;
          let newItem = filters.fromJson({
            FiltroId: data.data.FiltroId,
            Nombre: item.nombre,
            OperId: item.operId,
            Defecto: item.defecto,
            CreadoEl: item.creadoEl,
            Data: item.data,
          });

          options.push(newItem);
          commit("setFilters", { options: options });
          commit("setNewDefaultFilter", { filter: newItem });
        });
      } catch (error) {
        console.log(error);
      } finally {
        dispatch("loader/stopLoading", null, { root: true });
      }
    },
    async newController({ state, dispatch, commit }, params) {
      return new Promise(async (resolve, reject) => {
        let filter = params;
        state.saveFilter = params;
        if (!params?.id) {
          filter = state.filters.filter((item) => {
            return item.id === params;
          })[0];
        }

        try {
          dispatch("loader/startLoading", null, { root: true });
          await state.service
            .newController(state.date, filter?.data, state.dateTo)
            .then((data) => {
              let options = data;

              commit("setController", { options: options });
              resolve(data.length !== 0 ? true : false);
            });
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },
    async getRegis({ state, dispatch, commit }, params) {
      return new Promise(async (resolve, reject) => {
        let filter = params;
        state.saveFilter = params;
        try {
          dispatch("loader/startLoading", null, { root: true });
          await state.service
            .getRegis(state.date, filter?.data, state.dateTo)
            .then((data) => {
              let options = data;

              commit("setRegis", { options: options });
              resolve(data.length !== 0 ? true : false);
            });
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },
    async newControllerApply({ state, dispatch, commit }, params) {
      let apply = JSON.stringify(params.data);
      try {
        dispatch("loader/startLoading", null, { root: true });
        await state.service
          .newController(state.date, apply, state.dateTo)
          .then((data) => {
            let options = data;
            commit("setController", { options: options });
          });
      } catch (error) {
        console.log(error);
      } finally {
        dispatch("loader/stopLoading", null, { root: true });
      }
    },
    async processNovelty({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          let item = await state.service.processNovelty(state.processNovelty);

          commit("setProcessNovelty", item);
          resolve(true);
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },
    async refreshNovelty({ state, dispatch, commit }, params) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          let item = await state.service.refreshNovelty(
            state.dateForRefresh,
            params
          );

          commit("setRefreshNovelty", { item });
          resolve(true);
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },
    async showFilter({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          let item = await state.service.getShowFilter(state.idFilterShow);
          commit("setFilterForShow", item);
          resolve(true);
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },
    async editFilter({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          let item = await state.service.updatedFilter(state.idFilterShow);
          commit("setUpdatedFilter", item);
          resolve(true);
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },
  },
};
